module.exports = __webpack_public_path__ + "static/media/FeijaoCavaloClaro.4313d628.png";